import { buildDaySelectOptions, buildWeekDaySelectOption } from '@/modules/core/helper';

export const EvaluationFrequency = {
  EVERY_DAY: 'every_day',
  EVERY_WEEK_ON_DAY: 'every_week_on_day',
  EVERY_MONTH_ON_DAY: 'every_month_on_day',
  EVERY_QUARTER_ON_DAY: 'every_quarter_on_day',
};

export const EvaluationFrequencyEnum = {
  DAY: { key: EvaluationFrequency.EVERY_DAY, value: 'day' },
  WEEK: { key: EvaluationFrequency.EVERY_WEEK_ON_DAY, value: 'week' },
  MONTH: { key: EvaluationFrequency.EVERY_MONTH_ON_DAY, value: 'month' },
  QUARTER: { key: EvaluationFrequency.EVERY_QUARTER_ON_DAY, value: 'quarter' },
};

export const EvaluationFrequencyValues = {
  TODAY: [EvaluationFrequencyEnum.DAY],
  YESTERDAY: [EvaluationFrequencyEnum.DAY],
  THIS_WEEK: [EvaluationFrequencyEnum.WEEK],
  LAST_WEEK: [EvaluationFrequencyEnum.WEEK],
  LAST_7: [EvaluationFrequencyEnum.DAY, EvaluationFrequencyEnum.WEEK],
  LAST_14: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
  ],
  LAST_30: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
  ],
  LAST_90: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
    EvaluationFrequencyEnum.QUARTER,
  ],
  THIS_MONTH: [EvaluationFrequencyEnum.MONTH],
  THIS_MONTH_EXCLUDE_TODAY: [EvaluationFrequencyEnum.MONTH],
  LAST_MONTH: [EvaluationFrequencyEnum.MONTH],
  LAST_3: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
    EvaluationFrequencyEnum.QUARTER,
  ],
  LAST_6: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
    EvaluationFrequencyEnum.QUARTER,
  ],
  LAST_12: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
    EvaluationFrequencyEnum.QUARTER,
  ],
  LAST_13: [
    EvaluationFrequencyEnum.DAY,
    EvaluationFrequencyEnum.WEEK,
    EvaluationFrequencyEnum.MONTH,
    EvaluationFrequencyEnum.QUARTER,
  ],
  THIS_QUARTER: [EvaluationFrequencyEnum.QUARTER],
  LAST_QUARTER: [EvaluationFrequencyEnum.QUARTER],
};

export const EvaluationFrequencyOffsetValues = {
  [EvaluationFrequency.EVERY_WEEK_ON_DAY]: buildWeekDaySelectOption(),
  [EvaluationFrequency.EVERY_MONTH_ON_DAY]: buildDaySelectOptions(29),
  [EvaluationFrequency.EVERY_QUARTER_ON_DAY]: buildDaySelectOptions(91),
};

// TODO: Can be deleted after all the components support i18n
// Use GetRowAlertCriteriaValues to support localization.
export const RowAlertCriteriaValues = [
  { key: 'gt', value: 'greater than' },
  { key: 'lt', value: 'lesser than' },
  { key: 'eq', value: 'equal' },
];

// i18n friendly function to return translated array.
export function GetRowAlertCriteriaValues() {
  return [
    { key: 'gt', value: i18n.$t('greater than') },
    { key: 'lt', value: i18n.$t('lesser than') },
    { key: 'eq', value: i18n.$t('equal') },
  ];
}

export const DefaultRule = {
  metric_column: null,
  alert_threshold: null,
  row_alert_criteria: 'gt',
};

export const Operators = {
  CLIENT_ID: 'client_id',
  CLIENT_GROUP_ID: 'client_group_id',
  CLUSTER_ID: 'cluster_id',
  PAGE_ID: 'page_id',
  ALL_CLIENTS: 'all_clients',
};

export const AlertListName = {
  WIDGET_ALERT: 'WidgetAlertList',
  ALERT: 'AlertList',
  GOAL_ALERT: 'GoalAlertList',
};

export const AlertRoute = {
  ALERTS: 'alerts',
};

export const AlertPathName = {
  ALERTS: 'alerts',
  ALERTFORM: 'alertform',
  ALERTS_NEW: 'alertform:new',
  ALERTS_TAB: 'alerts:tab',
};

export const GoalAlertFields = {
  ID: 'id',
  NAME: 'name',
  GOAL_NAME: 'goal_name',
  GOAL_ASSOCIATION: 'goal_association',
  GOAL_METRIC: 'goal_metric',
  GOAL_STATUS: 'goal_status',
  GOAL_ID: 'goal_id',
};

export const AlertListFields = {
  ID: 'id',
  NAME: 'name',
  CLIENT_NAME: 'client_name',
  CLIENT_GROUP_NAME: 'client_group_name',
  CLUSTER_NAME: 'cluster_name',
  PAGE_TITLE: 'page_title',
};

export const EvaluationTimeFrame = {
  LAST_30: 'last_30',
};

export const AlertTabs = {
  PERFORMANCE: 'performance',
  WIDGET: 'widget',
  GOALS: 'goals',
};
